import script from "./TutoriaisPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TutoriaisPage.vue?vue&type=script&setup=true&lang=js"

import "./TutoriaisPage.vue?vue&type=style&index=0&id=3ef6cc1d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef6cc1d"]])

export default __exports__